
import React from "react";
import { Card, Button, Badge } from "react-bootstrap";

export default function NewsCard({ item, onVerMas }) {
  const fechaLocal = new Date(item.fecha).toLocaleDateString("es-HN", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <Card className="shadow-sm h-100">
      {item.imagen && (
        <Card.Img
          src={item.imagen}
          alt={item.titulo}
          style={{ objectFit: "cover", height: 180 }}
        />
      )}
      <Card.Body>
        <div className="d-flex justify-content-between align-items-start">
          <Badge bg="primary" className="mb-2">{item.categoria}</Badge>
          <small className="text-muted">{fechaLocal}</small>
        </div>
        <Card.Title className="fs-6">{item.titulo}</Card.Title>
        <Card.Text className="text-muted" style={{ minHeight: 48 }}>
          {item.resumen}
        </Card.Text>

        <div className="d-flex flex-wrap gap-1 mb-2">
          {(item.etiquetas ?? []).slice(0, 3).map((tag, i) => (
            <Badge bg="secondary" key={i} pill>#{tag}</Badge>
          ))}
        </div>

        <Button variant="outline-primary" size="sm" onClick={() => onVerMas(item)}>
          Ver más
        </Button>
      </Card.Body>
    </Card>
  );
}

